/* ==========================================================================
   OliveDrab — reels
   Autoplay muted in view, per reel play and sound controls, and a lightbox
   that plays with sound. Data saver and reduced motion are respected.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.ODConfig || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }

  function setup(root) {
    if (root.dataset.odReelsBound) return;
    // the stage layout has its own behaviour, in od-reels-stage.js
    if (root.dataset.layout === 'stage') return;
    root.dataset.odReelsBound = '1';

    var autoplay = root.dataset.autoplay === 'true' && !reduced() && !saveData();
    var reels = $$('[data-od-reel]', root);
    if (!reels.length) return;

    var mobile = window.matchMedia('(max-width: 749px)').matches;
    if (mobile && cfg.videoMobile === false) autoplay = false;

    /* ------------------------------------------------ per reel controls */

    reels.forEach(function (reel) {
      var video = $('[data-od-reel-video]', reel);
      var playBtn = $('[data-od-reel-play]', reel);
      var soundBtn = $('[data-od-reel-sound]', reel);
      var iPlay = $('[data-od-icon-play]', reel);
      var iPause = $('[data-od-icon-pause]', reel);
      var iMute = $('[data-od-icon-mute]', reel);
      var iSound = $('[data-od-icon-sound]', reel);

      if (!video) {
        // external embeds open straight in the lightbox
        if (playBtn) playBtn.hidden = true;
        if (soundBtn) soundBtn.hidden = true;
        return;
      }

      function syncPlayIcon() {
        var playing = !video.paused && !video.ended;
        if (iPlay) iPlay.hidden = playing;
        if (iPause) iPause.hidden = !playing;
        reel.classList.toggle('is-playing', playing);
      }

      function load() {
        if (video.dataset.odLoaded) return;
        $$('source[data-src]', video).forEach(function (s) {
          if (!s.src) s.src = s.getAttribute('data-src');
        });
        video.load();
        video.dataset.odLoaded = '1';
      }

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          load();
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          load();
          video.muted = !video.muted;
          soundBtn.setAttribute('aria-pressed', String(!video.muted));
          if (iMute) iMute.hidden = !video.muted;
          if (iSound) iSound.hidden = video.muted;
          if (!video.muted && video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
      }

      video.addEventListener('play', syncPlayIcon);
      video.addEventListener('pause', syncPlayIcon);
      video.addEventListener('ended', syncPlayIcon);
      syncPlayIcon();

      reel._load = load;
      reel._video = video;
    });

    /* --------------------------------------- play under the cursor
       In the gallery the stills stay quiet until the cursor lands on a
       tile, which is how the reference gallery behaves. Where autoplay
       is on, it still wins in view; this only covers the rest.      */

    if (
      root.dataset.hoverPlay === 'true' &&
      window.matchMedia('(hover: hover)').matches &&
      !reduced() &&
      !saveData()
    ) {
      reels.forEach(function (reel) {
        var video = reel._video;
        if (!video) return;

        reel.addEventListener('pointerenter', function () {
          if (reel._load) reel._load();
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        });

        reel.addEventListener('pointerleave', function () {
          if (!autoplay) video.pause();
        });
      });
    }

    /* ------------------------------------------------------- in view */

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var reel = entry.target;
          var video = reel._video;
          if (!video) return;

          if (entry.isIntersecting) {
            if (!autoplay) return;
            if (reel._load) reel._load();
            var p = video.play();
            if (p && p.catch) p.catch(function () { /* autoplay refused */ });
          } else {
            video.pause();
            if (!video.muted) {
              video.muted = true;
              var sb = $('[data-od-reel-sound]', reel);
              if (sb) sb.setAttribute('aria-pressed', 'false');
              var m = $('[data-od-icon-mute]', reel);
              var s2 = $('[data-od-icon-sound]', reel);
              if (m) m.hidden = false;
              if (s2) s2.hidden = true;
            }
          }
        });
      }, { threshold: 0.15 });

      reels.forEach(function (reel) { io.observe(reel); });
    }

    /* ------------------------------------------------------ lightbox */

    var box = $('[data-od-reel-box]', root);
    if (!box) return;

    /* The deck repeats its cards so the row is long enough to drift. Those
       repeats play, but they must not turn the lightbox into the same four
       films over and over. */
    var shots = reels.filter(function (r) { return !r.hasAttribute('data-od-dup'); });

    var stage = $('[data-od-reel-stage]', box);
    var prevBtn = $('[data-od-reel-prev]', box);
    var nextBtn = $('[data-od-reel-next]', box);
    var current = -1;
    var release = null;
    var lastFocus = null;

    function embedUrl(url) {
      // build an autoplaying embed from a YouTube or Vimeo watch URL
      var yt = url.match(/(?:youtube\.com\/.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{6,})/);
      if (yt) {
        return 'https://www.youtube.com/embed/' + yt[1] +
               '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
      }
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      return null;
    }

    function render(i) {
      var reel = shots[i];
      if (!reel) return;
      current = i;
      stage.innerHTML = '';

      var src = reel._video;
      var embed = $('[data-od-reel-embed]', reel);

      if (src) {
        var clone = src.cloneNode(true);
        clone.removeAttribute('data-od-lazy');
        clone.removeAttribute('poster');
        clone.muted = false;
        clone.controls = true;
        clone.loop = true;
        clone.playsInline = true;
        $$('source[data-src]', clone).forEach(function (s) {
          s.src = s.getAttribute('data-src');
        });
        stage.appendChild(clone);
        clone.load();
        var p = clone.play();
        if (p && p.catch) p.catch(function () {
          // sound was refused, fall back to a muted autoplay
          clone.muted = true;
          var r = clone.play();
          if (r && r.catch) r.catch(function () {});
        });
      } else if (embed) {
        var url = embedUrl(embed.dataset.url || '');
        if (!url) return;
        var frame = document.createElement('iframe');
        frame.src = url;
        frame.allow = 'autoplay; fullscreen; picture-in-picture';
        frame.setAttribute('allowfullscreen', '');
        frame.title = 'Reel';
        stage.appendChild(frame);
      }

      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= shots.length - 1;
    }

    function open(i) {
      lastFocus = document.activeElement;
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      if (window.OD && window.OD.lockScroll) window.OD.lockScroll();
      render(i);
      // pause everything in the rail while the lightbox is up
      reels.forEach(function (r) { if (r._video) r._video.pause(); });
      if (window.OD && window.OD.focusTrap) {
        release = window.OD.focusTrap($('.od-reel-box__inner', box), close);
      }
      var closeBtn = $('[data-od-reel-close]', box);
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
    }

    function close() {
      box.classList.remove('is-open');
      stage.innerHTML = '';
      if (window.OD && window.OD.unlockScroll) window.OD.unlockScroll();
      if (release) { release(); release = null; }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      setTimeout(function () {
        if (!box.classList.contains('is-open')) box.hidden = true;
      }, reduced() ? 0 : 300);
    }

    $$('[data-od-reel-close]', box).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { render(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { render(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowRight' && current < shots.length - 1) render(current + 1);
      if (e.key === 'ArrowLeft' && current > 0) render(current - 1);
    });

    reels.forEach(function (reel, i) {
      var frame = $('.od-reel__frame', reel);
      if (!frame) return;
      frame.addEventListener('click', function (e) {
        // never hijack the shoppable tag or the inline controls
        if (e.target.closest('.od-reel__tag')) return;
        if (e.target.closest('.od-reel__ctrl')) return;
        e.preventDefault();
        open(i);
      });
    });
  }

  function init(ctx) {
    $$('[data-od-reels]', ctx || document).forEach(function (root) {
      try { setup(root); } catch (e) {
        if (window.console && console.warn) console.warn('[OD reels]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
